import React from 'react';
import { Box, Typography, Grid, Card, CardContent } from '@mui/material';
import SentimentDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentDissatisfiedOutlined';
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';
import ChildFriendlyOutlinedIcon from '@mui/icons-material/ChildFriendlyOutlined';
import SpaOutlinedIcon from '@mui/icons-material/SpaOutlined';

const whoCards = [
  {
    icon: <SentimentDissatisfiedOutlinedIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />, // Feeling Lost
    title: 'Feeling Lost or Overwhelmed',
    desc: 'For those who feel emotionally tired, lost, or disconnected from themselves.'
  },
  {
    icon: <PsychologyOutlinedIcon sx={{ fontSize: 40, color: 'custom.red', mb: 1 }} />, // Overthinkers
    title: 'Overthinkers',
    desc: 'If you struggle to “switch off” and want a calm life but don’t know where to start.'
  },
  {
    icon: <ChildFriendlyOutlinedIcon sx={{ fontSize: 40, color: 'custom.blue', mb: 1 }} />, // Mothers & Women
    title: 'Mothers & Women in Transition',
    desc: 'Especially after motherhood or big life changes, this journey is for you.'
  },
  {
    icon: <SpaOutlinedIcon sx={{ fontSize: 40, color: 'custom.yellow', mb: 1 }} />, // Ready for Growth
    title: 'Ready for Gentle Growth',
    desc: 'If you want science-based tools and are ready to grow gently but deeply.'
  },
];

const WhoIsFor = () => (
  <Box sx={{ bgcolor: 'custom.yellow', py: { xs: 4, md: 6 }, px: { xs: 1, md: 0 } }}>
    <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
      <Typography variant="h2" sx={{ color: 'text.main', mb: 2, textAlign: 'center', fontFamily: 'Just Another Hand' }}>
        Who this is for
      </Typography>
      <Typography sx={{ mb: 4, color: 'text.secondary', textAlign: 'center', fontSize: { xs: 16, md: 18 } }}>
        This is for you if you…
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {whoCards.map((item, idx) => (
          <Grid item xs={12} sm={6} md={3} key={item.title}>
            <Card elevation={3} sx={{ borderRadius: 3, p: 2, height: '100%', bgcolor: 'background.paper', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>{item.icon}</Box>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>{item.title}</Typography>
                <Typography sx={{ color: 'text.secondary', fontSize: 15 }}>{item.desc}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Typography sx={{ color: 'text.secondary', textAlign: 'center', fontSize: { xs: 15, md: 17 }, mt: 4 }}>
        If you’re a mother: this journey is for you too.<br/>
        Because when a woman reconnects with herself, her whole life changes — including how she shows up for her children.
      </Typography>
    </Box>
  </Box>
);

export default WhoIsFor;
